export enum HoldingPaymentType {
    Comission = 1,
    Opportunity = 2,
    Order = 3
}
